<nav #navbar class="navbar active">
  <div class="container-fluid bg-white">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink="{{homePage}}">
        <img src="assets/images/logo/64.png" height="40px" width="40px" alt="" />
        <img src="assets/images/logo/TTLife.jpg" height="44px" width="100px" alt="" />
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <mat-icon *ngIf="isSideMenuClosed">chevron_right</mat-icon>
            <mat-icon *ngIf="!isSideMenuClosed">chevron_left</mat-icon>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class="nav-notification-icons">
            <mat-icon matTooltip="Full Screen" [matTooltipPosition]="'below'">fullscreen</mat-icon>
          </button>
        </li>
        <!-- Cart Icon -->
        <ng-container *ngIf="authService.currentUserValue?.user_role == 'Patient'">
          <li>
            <button mat-icon-button class="nav-notification-icons" routerLink="/patient/cart-list">
              <mat-icon matTooltip="My Cart" [matTooltipPosition]="'below'">shopping_cart_checkout</mat-icon>
              <span class="label-count bg-orange">{{this.total}}</span>
            </button>
          </li>
        </ng-container>
        <!-- <ng-container *ngIf="authService.currentUserValue?.user_role == 'Doctor'">
          <li>
            <button mat-icon-button class="nav-notification-icons" routerLink="/doctor/doctor-cart-list">
              <mat-icon matTooltip="My Cart" [matTooltipPosition]="'below'">shopping_cart_checkout</mat-icon>
              <span class="label-count bg-orange">{{this.total}}</span>
            </button>
          </li>
        </ng-container> -->
        <!-- saved Icon -->
        <ng-container *ngIf="authService.currentUserValue?.user_role == 'Patient'">
          <li class="fullscreen">
            <button mat-icon-button class="nav-notification-icons" routerLink="/patient/favorite-doctor-list">
              <!-- <mat-icon matTooltip="My Favorites" [matTooltipPosition]="'below'">bookmark_border</mat-icon> -->
              <mat-icon matTooltip="My Favorites" [matTooltipPosition]="'below'">favorite</mat-icon>
            </button>
          </li>
        </ng-container>
        <!-- <ng-container *ngIf="authService.currentUserValue?.user_role == 'Doctor'">
          <li class="fullscreen">
            <button mat-icon-button class="nav-notification-icons" routerLink="/doctor/fav-medicine">
              <mat-icon matTooltip="My Favorites" [matTooltipPosition]="'below'">bookmark_border</mat-icon>
            </button>
          </li>
        </ng-container> -->

        <!-- #END# Full Screen Button -->
        <li class="nav-item" ngbDropdown>
          <a ngbDropdownToggle class="lang-dropdown" matTooltip="Change Language" [matTooltipPosition]="'below'">
            <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" class="rounded-img">
            <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" class="rounded-img">
          </a>
          <div ngbDropdownMenu class="dropdown-menu lang-item dropdown-menu-right pullDown">
            <a href="javascript:void(0);" class="dropdown-item lang-item-list" *ngFor="let item of listLang"
              (click)="setLanguage(item.text, item.lang, item.flag)"
              [ngClass]="{'active': langStoreValue === item.lang}">
              <img src="{{item.flag}}" class="flag-img rounded-img" height="12"> <span class="align-middle">{{item.text
                | titlecase}}</span>
            </a>
          </div>
        </li>

        <!-- #START# Notifications-->
        <li class="nav-item" ngbDropdown>
          <ng-container *ngIf="authService.currentUserValue?.user_role == 'Hospital'">
            <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
              <mat-icon routerLink="/hospital/hospital-notification" matTooltip="Notifications"
                [matTooltipPosition]="'below'">notifications_active</mat-icon>
              <span class="label-count bg-orange">{{this.totalSize}}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="authService.currentUserValue?.user_role == 'Doctor'">
            <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
              <mat-icon routerLink="/doctor/read-all-notification" matTooltip="Notifications"
                [matTooltipPosition]="'below'">notifications_active</mat-icon>
              <span class="label-count bg-orange">{{this.totalSize}}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="authService.currentUserValue?.user_role == 'Patient'">
            <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
              <mat-icon routerLink="/patient/read-all-notification" matTooltip="Notifications"
                [matTooltipPosition]="'below'">notifications_active</mat-icon>
              <span class="label-count bg-orange">{{this.totalSize}}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="authService.currentUserValue?.user_role == 'medical_store'">
            <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
              <mat-icon routerLink="/pharmacy/read-all-notification" matTooltip="Notifications"
                [matTooltipPosition]="'below'">notifications_active</mat-icon>
              <span class="label-count bg-orange">{{this.totalSize}}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="authService.currentUserValue?.user_role == 'drug_store'">
            <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
              <mat-icon routerLink="/pharmacy/read-all-notification" matTooltip="Notifications"
                [matTooltipPosition]="'below'">notifications_active</mat-icon>
              <span class="label-count bg-orange">{{this.totalSize}}</span>
            </button>
          </ng-container>
        </li>
        <li class="nav-item" ngbDropdown>

        </li>
        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a href="#" onClick="return false;" matTooltip="Profile" [matTooltipPosition]="'below'" ngbDropdownToggle
            user_role="button" class="nav-notification-icons pt-0">
            <!-- <b>{{this.authService.currentUserValue.name |
              titlecase}}</b>
            &nbsp; -->
            <img [src]="userImg" (error)="img.src = 'assets/images/blank_profile.png'" #img class="rounded-circle"
              width="40" height="40" style="border-style: outset;" alt="User">
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown dropdown-menu-right">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <ng-container *ngIf="authService.currentUserValue?.user_role == 'Patient'">
                      <li>
                        <a href="#" routerLink="/patient/patient-profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Profile" |translate}}
                        </a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.currentUserValue?.user_role == 'Doctor'">
                      <li>
                        <a href="#" routerLink="/doctor/doctor-profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Doctor Profile" |translate}}
                        </a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.currentUserValue?.user_role == 'Hospital'">
                      <li>
                        <a href="#" routerLink="/hospital/profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Hospital Profile" |translate}}
                        </a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.currentUserValue?.user_role == 'medical_store'">
                      <li>
                        <a href="#" routerLink="/pharmacy/pharmacist-profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Pharmacy Profile" |translate}}
                        </a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.currentUserValue?.user_role == 'drug_store'">
                      <li>
                        <a href="#" routerLink="/pharmacy/pharmacist-profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Pharmacy Profile" |translate}}
                        </a>
                      </li>
                    </ng-container>

                    <!-- <ng-container *ngIf="authService.currentUserValue?.user_role == 'drug_store'">
                      <li>
                        <a href="#" routerLink="/pharmacy/pharmacist-profile" onClick="return false;">
                          <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>{{"Store Profile" |translate}}
                        </a>
                      </li>
                    </ng-container> -->
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">feedback</mat-icon>Feedback </a>
                    </li> -->
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>Help
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()">
                        <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>{{"Logout" |translate}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- <li class="nav-item" ngbDropdown>
          <a href="javascript:void(0);" (click)="logout()" matTooltip="Logout" [matTooltipPosition]="'below'">
            <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>
          </a>
        </li> -->


      </ul>
    </div>
  </div>
</nav>